export class GoogleWorkspaceGmailRestoreOptions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "label",
            "baseName": "label",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceGmailRestoreOptions.attributeTypeMap;
    }
    constructor() {
    }
}
